import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
    IMerchandiseListModel, IMerchandise, IVendor, IVendorList, IMerchandiseDiscount,
    IMerchandisDiscountDetailsActive, IDiscountList, INameExists, ICodeExists, IBarCodeExists, IFacilityMerchandiseModel, IInventoryAdjustmentReasonsSave, IReasonExists
} from '../Shared/interface';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import {AppService} from './app.service';


@Injectable({
    providedIn: 'root',
})

export class MerchandiseService {

    private baseURL = this.appService.config.apiBaseUrl;

    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    getMerchandiseList(): Observable<IMerchandiseListModel[]> {
        return this.http.get<IMerchandiseListModel[]>(
            `${this.baseURL}/merchandise/GetMerchandiseList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchandise = res.body as IMerchandiseListModel[];
                    return merchandise;
                }),
                catchError(this.handleError)
            );
    }

    getMerchandise(): Observable<IMerchandiseListModel[]> {
        return this.http.get<IMerchandiseListModel[]>(
            `${this.baseURL}/merchandise/GetMerchandiseList`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchandise = res.body as IMerchandiseListModel[];
                    return merchandise;
                }),
                catchError(this.handleError)
            );
    }

    getAllMerchandise(storeId): Observable<IFacilityMerchandiseModel> {
        return this.http.get<IFacilityMerchandiseModel>(
            `${this.baseURL}/Store/GetFacilityMerchandise?stroreId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchDetail = res.body as IFacilityMerchandiseModel;
                    return merchDetail;
                }),
                catchError(this.handleError)
            );

    }

    getAllMerchandiseForOp(storeId): Observable<IFacilityMerchandiseModel> {
        return this.http.get<IFacilityMerchandiseModel>(
            `${this.baseURL}/Store/GetFacilityMerchandiseForOp?stroreId=${storeId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchDetail = res.body as IFacilityMerchandiseModel;
                    return merchDetail;
                }),
                catchError(this.handleError)
            );

    }

    getMerchDetail(id: number): Observable<IMerchandise> {
        return this.http.get<IMerchandise>(
            `${this.baseURL}/merchandise/GetMerchandiseByID?id=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const merchDetail = res.body as IMerchandise;
                    return merchDetail;
                }),
                catchError(this.handleError)
            );

    }

    saveMerchDetail(merch: IMerchandise): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (merch.Id === 0) {
            url = `${this.baseURL}/merchandise/CreateMerchandise`;
        }
        else {
            url = `${this.baseURL}/merchandise/UpdateMerchandise`;
        }
        return this.http.post<boolean>(url, merch, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    saveVendorMerch(vendor: IVendor): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        // const url = `${this.baseURL}/Vendor/SaveVendorDetail`;
        if (vendor.Id === 0) {
            url = `${this.baseURL}/Vendor/CreateVendor`;
        } else {
            url = `${this.baseURL}/Vendor/UpdateVendorDetails`;
        }
        return this.http.post<boolean>(url, vendor, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    saveMerchDiscount(merch: IMerchandiseDiscount): Observable<number> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (merch.Id === 0) {
            url = `${this.baseURL}/merchandise/CreateMerchandiseDiscount`;
        } else {
            url = `${this.baseURL}/merchandise/UpdateMerchandiseDiscount`;
        }
        return this.http.post<number>(url, merch, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    deleteMerch(merchId: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.post<any>(`${this.baseURL}/merchandise/DeleteMerchandise?id=${merchId}`, options);
    }

    getVendorList(): Observable<IVendorList[]> {
        const url = `${this.baseURL}/Vendor/GetVendorsForOp`;
        return this.http.get<IVendorList[]>(url,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Vendors = res.body as IVendorList[];
                    return Vendors;
                }),
                catchError(this.handleError)
            );
    }

    getMerchDiscount(): Observable<IMerchandiseDiscount[]> {
        const url = `${this.baseURL}/merchandise/GetMerchDiscount`;
        return this.http.get<IMerchandiseDiscount[]>(url,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const discount = res.body as IMerchandiseDiscount[];
                    return discount;
                }),
                catchError(this.handleError)
            );
    }

    IsBarcodeExist(Barcode: string): Observable<IBarCodeExists> {
        const url = `${this.baseURL}/merchandise/GetMerchandiseBarcodeExists?barcode=${Barcode}`;
        return this.http.get<IBarCodeExists>(url,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const isExist = result.body as IBarCodeExists;
                    return isExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    getDiscountsList(): Observable<IDiscountList[]> {
        return this.http.get<IDiscountList[]>(
            `${this.baseURL}/discounts/GetDiscounts`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const reportGroup = res.body as IDiscountList[];
                    return reportGroup;
                }),
                catchError(this.handleError)
            );
    }

    updateMerchandiseDiscountDetails(merchDisc: IMerchandisDiscountDetailsActive): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (merchDisc.Id === 0) {
            url = `${this.baseURL}/discounts/CreateMerchandiseDiscount`;
        } else {
            url = `${this.baseURL}/discounts/UpdateMerchandiseDiscount`;
        }
        return this.http.post<any>(url, merchDisc, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getIsMerchNameExist(merch: string): Observable<INameExists> {
        return this.http.get<INameExists>(
            `${this.baseURL}/merchandise/GetMerchandiseNameExists?name=${merch}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const NameExist = result.body as INameExists;
                    return NameExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    getIsMerchCodeExist(merch: string): Observable<ICodeExists> {
        return this.http.get<ICodeExists>(
            `${this.baseURL}/merchandise/GetMerchandiseCodeExists?code=${merch}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const CodeExist = result.body as ICodeExists;
                    return CodeExist;
                }
                ),
                catchError(this.handleError)
            );
    }

    saveInventoryAdjustReasons(inv: IInventoryAdjustmentReasonsSave): Observable<number> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/Merchandise/SaveInventoryAdjustmentReasons`;
        
        return this.http.post<number>(url, inv, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    deleteInventoryAdjustmentReasons(InventoryAdjustmentReasonsId: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<any>(`${this.baseURL}/Merchandise/DeleteInventoryAdjustmentReasons?InventoryAdjustmentReasonsId=${InventoryAdjustmentReasonsId}`, options);
    }

    getInventoryAdjustmentReasonsExist(name: string): Observable<IReasonExists> {
        return this.http.get<IReasonExists>(
            `${this.baseURL}/Merchandise/InventoryAdjustmentReasonsExists?InventoryAdjustmentReasonsName=${name}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as IReasonExists;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

    private handleHttpPostError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error);
            return of(result as T);
        };
    }


}
